import Program from "./views/Program/Create";
import Dashboard from "./views/Dashboard";
import Approval from "./views/Program/Approval";
import Member from "./views/Member/Create";
import MemberSummary from "./views/Member/Summary";

// Program
import ProgramSummary from "./views/Program/Summary";
import ProgramSummaryDetail from "./views/Program/SummaryDetail";
import ProgramUpload from "./views/Program/Upload";

import EditBudgetSummary from "./views/Program/EditBudgetSummary";
import EditBudgetDetail from "./views/Program/EditBudgetDetail";

// Assignment
import Assign from "./views/Assignment/Assign";
import ApprovalDetail from "./views/Program/ApprovalDetail";
import AssignDetail from "./views/Assignment/AssignDetail";
import AssignSummary from "./views/Assignment/AssignSummary";
import AssignSummaryDetail from "./views/Assignment/AssignSummaryDetail";

// Claim
import ClaimDetail from "./views/Claim/Detail";
import ClaimAssignment from "./views/Claim/SummaryAssignment";
import ClaimSummary from "./views/Claim/Summary";
import ClaimSummaryDetail from "./views/Claim/DetailSummary";

// Report
import ReportSKP from "./views/ReportProgram/skp";
import ReportProgram from "./views/ReportProgram/program";
import ReportAssignment from "./views/ReportProgram/assignment";
import ReportClaim from "./views/ReportProgram/claim";
import ReportClaimHO from "./views/ReportProgram/claimho";
import ReportBalance from "./views/ReportProgram/balance";
import ReportBalanceDetail from "./views/ReportProgram/balance_detail";
import ReportTracesBalanceDetail from "./views/ReportProgram/tracesBalanceDetail";

import ClaimReject from "./views/Claim/Reject";
import ClaimRejectDetail from "./views/Claim/RejectDetail";
import ClaimSummaryValidate from "./views/Claim/ValidateSummary";
import ClaimDetailValidate from "./views/Claim/Validate";

// Approval
import ClaimApproval from "./views/Claim/Approval";
import ClaimApprovalSummary from "./views/Claim/SummaryApproval";

import Reject from "./views/Program/Reject";
import RejectDetail from "./views/Program/RejectDetail";
import UploadBupot from "./views/Claim/Upload";
import UploadBupotDetail from "./views/Claim/UploadDetail";

import submitAWB from "./views/AWB/Submit";
import claimDetailAWB from "./views/AWB/Detail";
import awbpdf from "./views/AWB/Document";
import receiveAWB from "./views/AWB/Receive";
import CoverLetter from "./views/AWB/CoverLetter";
import AwbReprint from "./views/AWB/AwbReprint";
import SubmitPrincipal from "./views/AWB/SubmitPrincipal";
import userlist from "./views/Setup/userList";
import userupdate from "./views/Setup/userUpdate";
import usernew from "./views/Setup/userNew";
import pphType from "./views/Setup/pphType";
import roleSetup from "./views/Setup/roleSetup";
import responsibility from "./views/Setup/responsibility";
import progType from "./views/Setup/programType";
import BMgroup from "./views/Setup/BMgroup";
import ReportBranch from "./views/ReportProgram/forbranch";
import ReportPrincipal from "./views/ReportProgram/forprincipal";
import ReportUnassign from "./views/ReportProgram/unassign";

// CHD
import ClaimSummaryCHD from "./views/CHD/Claim/SummarySubmit";
import ClaimDetailCHD from "./views/CHD/Claim/Submit";
import ProgramCHD from "./views/CHD/Program/Create";

import SummaryApprovalCHD from "./views/CHD/Program/SummaryApproval";
import ApprovalProgramCHD from "./views/CHD/Program/Approval";

import SummaryRejectCHD from "./views/CHD/Program/SummaryReject";
import RejectProgramCHD from "./views/CHD/Program/Reject";

import SumaryAllProgramCHD from "./views/CHD/Program/SummaryAll";
import ViewProgramCHD from "./views/CHD/Program/View";

import SummaryAssignmentCHD from "./views/CHD/Assignment/SummaryAssignment";
import AssignmentCHD from "./views/CHD/Assignment/Assignment";
import SummaryAssignmentAllCHD from "./views/CHD/Assignment/SummaryAllAssignment";
import DetailSummaryAssignmentCHD from "./views/CHD/Assignment/DetailSummary";

import SummaryApprovalClaimCHD from "./views/CHD/Claim/SummaryApproval";
import ApprovalClaimCHD from "./views/CHD/Claim/Approval";

import SummaryRejectClaimCHD from "./views/CHD/Claim/SummaryReject";
import RejectClaimCHD from "./views/CHD/Claim/Reject";

import SummaryAllClaimCHD from "./views/CHD/Claim/SummaryAll";
import ViewClaimCHD from "./views/CHD/Claim/View";
import OpenKwitansi from "./views/CHD/Claim/OpenKwitansi";

import PaymentListCHD from "./views/CHD/Payment/List";
import PaymentRequest from "./views/CHD/Payment/request";
import PaymentProcess from "./views/CHD/Payment/process";
import PaymentProcessDetail from "./views/CHD/Payment/process-detail";
import PaymentReject from "./views/CHD/Payment/reject";
import ListPaymentReject from "./views/CHD/Payment/re-process";

import SetupCustomerList from "./views/Setup/customer/index";
import SetupCustomerForm from "./views/Setup/customer/create";
import SetupCustomerApproval from "./views/Setup/customer/approval";
import SetupCustomerApprovalList from "./views/Setup/customer/summary_approval";
import SetupCustomerValidation from "./views/Setup/customer/validation";
import SetupCustomerActivation from "./views/Setup/customer/activation";
import SetupCustomerValidationList from "./views/Setup/customer/summary_validate";
import SetupCustomerActivationList from "./views/Setup/customer/summary_activate";

import UploadDocumentSKP from "./views/CHD/Assignment/UploadDocument";
import UploadKwitansi from "./views/CHD/Claim/UploadKwitansi";
import ScanKwitansi from "./views/CHD/Claim/ScanKwitansi";
import SummaryUploadDocumentSKP from "./views/CHD/Claim/SummaryUpload";

import ReportClaimCHD from "./views/CHD/Report/Claim";
import ExceptionReport from "./views/CHD/Report/Exception";
import ReportAssignmentCHD from './views/CHD/Report/Assignment';

import ListMaster from "./views/CHD/Recommendation/ListMaster";
import ListRecommendation from "./views/CHD/Recommendation/ListRecommendation";
import DetailMaster from "./views/CHD/Recommendation/DetailMaster";
import ListApproval from "./views/CHD/Recommendation/ListApproval";
import DetailApproval from "./views/CHD/Recommendation/DetailApproval";
import DetailRecommendation from "./views/CHD/Recommendation/DetailRecommendation";

// END OF CHD MODULE

import SetupPackageList from "./views/Setup/package/index";
import SetupPackageForm from "./views/Setup/package/create";
// import ClaimSummaryCHD from "./views/Claim/CHD/Summary";
// import ClaimDetailCHD from "./views/Claim/CHD/DetailSummary";
import MultiUploadBukpot from "./views/Claim/multiUploadBukpot";

//================
// COLLECTION
//================

import CollMonSendDocument from "./views/Collection/DocumentMonitoring/SendDocument";
import ReceiptDocCab from "./views/Collection/DocumentMonitoring/ReceiptDocCab";
import ReceiptDocCabDetail from "./views/Collection/DocumentMonitoring/ReceiptDocCabDetail";
import ReceiptDocCus from "./views/Collection/DocumentMonitoring/ReceiptDocCus";
import ReceiptDocCusDetail from "./views/Collection/DocumentMonitoring/ReceiptDocCusDetail";
import SummaryDoc from "./views/Collection/DocumentMonitoring/Summary";
import DetailDoc from "./views/Collection/DocumentMonitoring/Detail";
import HistoryDoc from "./views/Collection/DocumentMonitoring/History";
import HistoryDocHO from "./views/Collection/DocumentMonitoring/HistoryHO";
import ScanOpnameDebitur from "./views/Collection/OpnameDebitur/Scan";
import ActivateOpnameDebitur from "./views/Collection/OpnameDebitur/Activation";
import Unidentified from "./views/Collection/Unidentified";
import ScanInv from "./views/Collection/TrxMonitoring/ScanInv";
import ReportSummaryDoc from "./views/Collection/DocumentMonitoring/ReportSummary";
import ReportDocGroup from "./views/Collection/DocumentMonitoring/ReportDocGroup";
import ReportTracesDoc from "./views/Collection/DocumentMonitoring/ReportTraceDoc";
import ReportDocMonitoringInternal from "./views/Collection/DocumentMonitoring/ReportDocMonitoringInternal";
import SalesTarget from "./views/Upload/SalesTarget";
import ApprovalSalesTarget from "./views/Upload/ApprovalSalesTarget";
import UploadEBupotNew from "./views/Claim/UploadEBupotNew";
import TracesEmailLogBupot from "./views/ReportProgram/tracesEmailLogBupot";
import InsertBupot from "./views/Claim/InsertBupot";
import ReportRpaReceipt from "./views/ReportProgram/reportRpaReceipt";
import FormMonitoringWHT from "./views/ReportProgram/formMonitoringWHT";

const dashboardRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "pe-7s-bell",
    component: Dashboard,
    layout: "/admin",
  },
  {
    path: "/program/create",
    name: "Program",
    icon: "pe-7s-bell",
    component: Program,
    layout: "/admin",
  },
  {
    path: "/program/approval",
    name: "Approval",
    icon: "pe-7s-bell",
    component: Approval,
    layout: "/admin",
  },
  {
    path: "/program/approval/:id",
    name: "Approval",
    icon: "pe-7s-bell",
    component: ApprovalDetail,
    layout: "/admin",
  },
  {
    path: "/assign/assign",
    name: "Assignment",
    icon: "pe-7s-bell",
    component: Assign,
    layout: "/admin",
  },
  {
    path: "/assign/assign/:id",
    name: "AssignmentDetail",
    icon: "pe-7s-bell",
    component: AssignDetail,
    layout: "/admin",
  },
  {
    path: "/assign/summary",
    name: "SummaryAssign",
    icon: "pe-7s-bell",
    component: AssignSummary,
    layout: "/admin",
  },
  {
    path: "/assign/summary/:id",
    name: "SummaryAssignDetail",
    icon: "pe-7s-bell",
    component: AssignSummaryDetail,
    layout: "/admin",
  },
  {
    path: "/program/summary",
    name: "Summary",
    icon: "pe-7s-bell",
    component: ProgramSummary,
    layout: "/admin",
  },
  {
    path: "/program/summary/:id",
    name: "SummaryDetail",
    icon: "pe-7s-bell",
    component: ProgramSummaryDetail,
    layout: "/admin",
  },

  {
    path: "/program/EditBudgetSummary",
    name: "Edit Program",
    icon: "pe-7s-bell",
    component: EditBudgetSummary,
    layout: "/admin",
  },

  {
    path: "/program/EditBudgetSummary/:id",
    name: "Edit Program Detail",
    icon: "pe-7s-bell",
    component: EditBudgetDetail,
    layout: "/admin",
  },

  {
    path: "/program/upload",
    name: "Upload Program",
    icon: "pe-7s-bell",
    component: ProgramUpload,
    layout: "/admin",
  },
  {
    path: "/member/create/:id",
    name: "Create",
    icon: "pe-7s-bell",
    component: Member,
    layout: "/admin",
  },
  {
    path: "/member",
    name: "Summary",
    icon: "pe-7s-bell",
    component: MemberSummary,
    layout: "/admin",
  },
  {
    path: "/claim-chd/submit",
    name: "Summary Claim CHD",
    icon: "pe-7s-bell",
    component: ClaimSummaryCHD,
    layout: "/admin",
  },
  {
    path: "/claim-chd/submit/:id",
    name: "Detail Claim CHD",
    icon: "pe-7s-bell",
    component: ClaimDetailCHD,
    layout: "/admin",
  },
  {
    path: "/claim-chd/re-print-kwitansi",
    name: "Re-Print Kwitansi",
    icon: "pe-7s-bell",
    component: OpenKwitansi,
    layout: "/admin",
  },
  {
    path: "/claim/submit",
    name: "Submit Claim",
    icon: "pe-7s-bell",
    component: ClaimAssignment,
    layout: "/admin",
  },
  {
    path: "/claim/submit/:id",
    name: "Submit Claim",
    icon: "pe-7s-bell",
    component: ClaimDetail,
    layout: "/admin",
  },
  {
    path: "/claim/summary",
    name: "Summary Claim",
    icon: "pe-7s-bell",
    component: ClaimSummary,
    // component: NewSummary,
    layout: "/admin",
  },
  {
    path: "/claim/view/:id",
    name: "Summary Detail",
    icon: "pe-7s-bell",
    component: ClaimSummaryDetail,
    layout: "/admin",
  },
  {
    path: "/claim/approval-summary",
    name: "Summary Approval",
    icon: "pe-7s-bell",
    component: ClaimApprovalSummary,
    layout: "/admin",
  },
  {
    path: "/claim/approval/:id",
    name: "Detail Approval",
    icon: "pe-7s-bell",
    component: ClaimApproval,
    layout: "/admin",
  },

  {
    path: "/report/traces/balance/detail",
    name: "Report Traces Balance Detail",
    icon: "pe-7s-bell",
    component: ReportTracesBalanceDetail,
    layout: "/admin",
  },
  {
    path: "/reportprogram/balance",
    name: "Report Balance Claim",
    icon: "pe-7s-bell",
    component: ReportBalance,
    layout: "/admin",
  },
  {
    path: "/reportprogram/balance/:id",
    name: "Report Balance Claim",
    icon: "pe-7s-bell",
    component: ReportBalanceDetail,
    layout: "/admin",
  },
  {
    path: "/reportprogram/assignment",
    name: "Report Assignment",
    icon: "pe-7s-bell",
    component: ReportAssignment,
    layout: "/admin",
  },
  {
    path: "/reportprogram/claim",
    name: "Report Claim",
    icon: "pe-7s-bell",
    component: ReportClaim,
    layout: "/admin",
  },
  {
    path: "/reportprogram/skp",
    name: "Report SKP",
    icon: "pe-7s-bell",
    component: ReportSKP,
    layout: "/admin",
  },
  {
    path: "/reportprogram/program",
    name: "Report Program",
    icon: "pe-7s-bell",
    component: ReportProgram,
    layout: "/admin",
  },
  {
    path: "/reportprogram/claim-ho",
    name: "Report Claim HO",
    icon: "pe-7s-bell",
    component: ReportClaimHO,
    layout: "/admin",
  },
  {
    path: "/claim/reject",
    name: "Rejected",
    icon: "pe-7s-bell",
    component: ClaimReject,
    layout: "/admin",
  },
  {
    path: "/claim/reject/:id",
    name: "Rejected",
    icon: "pe-7s-bell",
    component: ClaimRejectDetail,
    layout: "/admin",
  },
  {
    path: "/reject",
    name: "Rejected",
    icon: "pe-7s-bell",
    component: Reject,
    layout: "/admin",
  },
  {
    path: "/reject/:id",
    name: "Rejected",
    icon: "pe-7s-bell",
    component: RejectDetail,
    layout: "/admin",
  },
  {
    path: "/claim/upload",
    name: "Upload E-Bupot",
    icon: "",
    component: UploadBupot,
    layout: "/admin",
  },
  {
    path: "/claim/upload/:id",
    name: "Upload E-Bupot",
    icon: "",
    component: UploadBupotDetail,
    layout: "/admin",
  },
  {
    path: "/claim/MultiUploadBukpot",
    name: "Multi Upload E-Bupot",
    icon: "",
    component: MultiUploadBukpot,
    layout: "/admin",
  },
  // ! edit by ponco ()
  {
    path: "/claim/multiupload-bupot",
    name: "Upload E-Bupot New",
    icon: "",
    component: UploadEBupotNew,
    layout: "/admin",
  },

  {
    path: "/reportprogram/forprincipal",
    name: "Traces Principal",
    icon: "pe-7s-bell",
    component: ReportPrincipal,
    layout: "/admin",
  },
  {
    path: "/reportprogram/unassign",
    name: "Report Assignment",
    icon: "pe-7s-bell",
    component: ReportUnassign,
    layout: "/admin",
  },
  {
    path: "/reportprogram/forbranch",
    name: "Traces Branch",
    icon: "pe-7s-bell",
    component: ReportBranch,
    layout: "/admin",
  },
  {
    path: "/awb/submit",
    name: "Submit AWB",
    icon: "",
    component: submitAWB,
    layout: "/admin",
  },
  {
    path: "/awb/view/:id",
    name: "Claim Detail",
    icon: "",
    component: claimDetailAWB,
    layout: "/admin",
  },
  {
    path: "/awb/view/doc",
    name: "Claim Detail",
    icon: "",
    component: awbpdf,
    layout: "/admin",
  },
  {
    path: "/awb/receive",
    name: "Receive AWB",
    icon: "",
    component: receiveAWB,
    layout: "/admin",
  },

  {
    path: "/document/AwbReprint",
    name: "Reprint - AWB",
    icon: "",
    component: AwbReprint,
    layout: "/admin",
  },

  {
    path: "/document/cover-letter",
    name: "Generate Cover Letter",
    icon: "",
    component: CoverLetter,
    layout: "/admin",
  },

  {
    path: "/awb/submit-principal",
    name: "Submit to Principal",
    icon: "",
    component: SubmitPrincipal,
    layout: "/admin",
  },
  {
    path: "/setup/user/userlist",
    name: "Ar Management Users",
    icon: "",
    component: userlist,
    layout: "/admin",
  },
  {
    path: "/setup/user/userupdate/:id",
    name: "Update User",
    icon: "",
    component: userupdate,
    layout: "/admin",
  },
  {
    path: "/setup/user/usernew",
    name: "New User",
    icon: "",
    component: usernew,
    layout: "/admin",
  },
  {
    path: "/setup/master/programtype",
    name: "Program Type Setup",
    icon: "",
    component: progType,
    layout: "/admin",
  },
  {
    path: "/setup/master/bmgroup",
    name: "BM Approval Setup",
    icon: "",
    component: BMgroup,
    layout: "/admin",
  },
  {
    path: "/setup/master/pphtype",
    name: "PPh Type Setup",
    icon: "",
    component: pphType,
    layout: "/admin",
  },
  {
    path: "/setup/master/role",
    name: "Arman Role Setup",
    icon: "",
    component: roleSetup,
    layout: "/admin",
  },
  {
    path: "/setup/master/responsibility",
    name: "Arman Resopnsibility Setup",
    icon: "",
    component: responsibility,
    layout: "/admin",
  },
  {
    path: "/claimvalid/summaryvalidate",
    name: "Claim Validation",
    icon: "",
    component: ClaimSummaryValidate,
    layout: "/admin",
  },
  {
    path: "/claimvalid/summaryvalidate/:id",
    name: "Update",
    icon: "",
    component: ClaimDetailValidate,
    layout: "/admin",
  },
  {
    path: "/program-chd/create",
    name: "Create",
    icon: "",
    component: ProgramCHD,
    layout: "/admin",
  },
  {
    path: "/program-chd/approval",
    name: "Summary Approval",
    icon: "",
    component: SummaryApprovalCHD,
    layout: "/admin",
  },
  {
    path: "/program-chd/approval/:id",
    name: "Form Approval",
    icon: "",
    component: ApprovalProgramCHD,
    layout: "/admin",
  },
  {
    path: "/program-chd/reject",
    name: "Summary Rejection Program",
    icon: "",
    component: SummaryRejectCHD,
    layout: "/admin",
  },
  {
    path: "/program-chd/reject/:id",
    name: "Form Program",
    icon: "",
    component: RejectProgramCHD,
    layout: "/admin",
  },
  {
    path: "/program-chd/summary",
    name: "Summary Program",
    icon: "",
    component: SumaryAllProgramCHD,
    layout: "/admin",
  },
  {
    path: "/program-chd/summary/:id",
    name: "Summary Program Detail",
    icon: "",
    component: ViewProgramCHD,
    layout: "/admin",
  },
  {
    path: "/assignment-chd/assignment/:id",
    name: "Form Assigment Program",
    icon: "",
    component: AssignmentCHD,
    layout: "/admin",
  },
  {
    path: "/assignment-chd/summary",
    name: "Summary Assignment Program",
    icon: "",
    component: SummaryAssignmentCHD,
    layout: "/admin",
  },
  {
    path: "/assignment-chd/summary-all",
    name: "Summary Assignment Program All",
    icon: "",
    component: SummaryAssignmentAllCHD,
    layout: "/admin",
  },
  {
    path: "/assignment-chd/assignment-detail/:id",
    name: "Detail Assignment Program",
    icon: "",
    component: DetailSummaryAssignmentCHD,
    layout: "/admin",
  },
  {
    path: "/claim-chd/approval",
    name: "Summary Approval Claim",
    icon: "",
    component: SummaryApprovalClaimCHD,
    layout: "/admin",
  },
  {
    path: "/claim-chd/approval/:id",
    name: "Form Approval Claim",
    icon: "",
    component: ApprovalClaimCHD,
    layout: "/admin",
  },
  {
    path: "/claim-chd/reject",
    name: "Summary Reject Claim",
    icon: "",
    component: SummaryRejectClaimCHD,
    layout: "/admin",
  },
  {
    path: "/claim-chd/reject/:id",
    name: "Form Reject Claim",
    icon: "",
    component: RejectClaimCHD,
    layout: "/admin",
  },
  {
    path: "/claim-chd/summary",
    name: "Summary All Claim",
    icon: "",
    component: SummaryAllClaimCHD,
    layout: "/admin",
  },
  {
    path: "/claim-chd/summary/:id",
    name: "Form Claim",
    icon: "",
    component: ViewClaimCHD,
    layout: "/admin",
  },
  {
    path: "/payment-chd/list",
    name: "Payment List",
    icon: "",
    component: PaymentListCHD,
    layout: "/admin",
  },
  {
    path: "/payment-chd/request",
    name: "Payment Request List",
    icon: "",
    component: PaymentRequest,
    layout: "/admin",
  },
  {
    path: "/payment-chd/process",
    name: "Payment Process List",
    icon: "",
    component: PaymentProcess,
    layout: "/admin",
  },
  {
    path: "/payment-chd/process/:id",
    name: "Payment Process Detail",
    icon: "",
    component: PaymentProcessDetail,
    layout: "/admin",
  },
  {
    path: "/payment-chd/reject",
    name: "Payment Reject",
    icon: "",
    component: PaymentReject,
    layout: "/admin",
  },
  {
    path: "/payment-chd/list-reject",
    name: "Payment Reject",
    icon: "",
    component: ListPaymentReject,
    layout: "/admin",
  },
  {
    path: "/report-chd/claim",
    name: "Report Claim",
    icon: "",
    component: ReportClaimCHD,
    layout: "/admin",
  },
  {
    path: "/report-chd/exception",
    name: "Report Exception",
    icon: "",
    component: ExceptionReport,
    layout: "/admin",
  },
  {
    path: "/report-chd/assignment",
    name: "Report Assignment",
    icon: "",
    component: ReportAssignmentCHD,
    layout: "/admin",
  },
  {
    path: "/setup/customer/list",
    name: "List Customer",
    icon: "",
    component: SetupCustomerList,
    layout: "/admin",
  },
  {
    path: "/setup/customer/create",
    name: "Form Customer",
    icon: "",
    component: SetupCustomerForm,
    layout: "/admin",
  },
  {
    path: "/setup/customer/approve",
    name: "Form Approval",
    icon: "",
    component: SetupCustomerApproval,
    layout: "/admin",
  },
  {
    path: "/setup/customer/validate",
    name: "Form Validation",
    icon: "",
    component: SetupCustomerValidationList,
    layout: "/admin",
  },
  {
    path: "/setup/customer/validate/:id",
    name: "Form Validation",
    icon: "",
    component: SetupCustomerValidation,
    layout: "/admin",
  },
  {
    path: "/setup/customer/activate/:id",
    name: "Form Activation",
    icon: "",
    component: SetupCustomerActivation,
    layout: "/admin",
  },
  {
    path: "/setup/customer/activate",
    name: "Form Activation",
    icon: "",
    component: SetupCustomerActivationList,
    layout: "/admin",
  },
  {
    path: "/setup/customer/approval-list",
    name: "Approval Customer",
    icon: "",
    component: SetupCustomerApprovalList,
    layout: "/admin",
  },
  {
    path: "/setup/package/list",
    name: "List Package",
    icon: "",
    component: SetupPackageList,
    layout: "/admin",
  },
  {
    path: "/setup/package/create",
    name: "Form Package",
    icon: "",
    component: SetupPackageForm,
    layout: "/admin",
  },
  {
    path: "/assignment-chd/upload-doc/:id",
    name: "Form Upload Document",
    icon: "",
    component: UploadDocumentSKP,
    layout: "/admin",
  },
  {
    path: "/claim-chd/upload-kwitansi/:id",
    name: "Form Upload Kwitansi",
    icon: "",
    component: UploadKwitansi,
    layout: "/admin",
  },
  {
    path: "/claim-chd/scan-kwitansi",
    name: "Form Scan Kwitansi",
    icon: "",
    component: ScanKwitansi,
    layout: "/admin",
  },
  {
    path: "/documentmonitor/send",
    name: "SEND DOCUMENT",
    icon: "pe-7s-bell",
    component: CollMonSendDocument,
    layout: "/admin",
  },

  {
    path: "/trxmonitor/scaninv",
    name: "Scan Invoice - CN",
    icon: "pe-7s-bell",
    component: ScanInv,
    layout: "/admin",
  },

  {
    path: "/documentmonitor/receiptcab",
    name: "RECEIPT DOCUMENTS - Branch Confirmation",
    icon: "pe-7s-bell",
    component: ReceiptDocCab,
    layout: "/admin",
  },

  {
    path: "/documentmonitor/receiptcab/:id",
    name: "RECEIPT DOCUMENTS - Detail",
    icon: "pe-7s-bell",
    component: ReceiptDocCabDetail,
    layout: "/admin",
  },

  {
    path: "/documentmonitor/receiptcus",
    name: "RECEIPT DOCUMENTS - Customer Confirmation",
    icon: "pe-7s-bell",
    component: ReceiptDocCus,
    layout: "/admin",
  },

  {
    path: "/documentmonitor/receiptcus/:id",
    name: "RECEIPT DOCUMENTS - Customer - Detail",
    icon: "pe-7s-bell",
    component: ReceiptDocCusDetail,
    layout: "/admin",
  },

  {
    path: "/documentmonitor/summary",
    name: "Document Summary",
    icon: "pe-7s-bell",
    component: SummaryDoc,
    layout: "/admin",
  },

  {
    path: "/documentmonitor/summary/:id",
    name: "Document Detail",
    icon: "pe-7s-bell",
    component: DetailDoc,
    layout: "/admin",
  },

  {
    path: "/documentmonitor/history",
    name: "History",
    icon: "pe-7s-bell",
    component: HistoryDoc,
    layout: "/admin",
  },
  {
    path: "/documentmonitor/historyHO",
    name: "History",
    icon: "pe-7s-bell",
    component: HistoryDocHO,
    layout: "/admin",
  },
  {
    path: "/opname-debitur/scan",
    name: "Opname Debitur",
    icon: "pe-7s-bell",
    component: ScanOpnameDebitur,
    layout: "/admin",
  },
  {
    path: "/opname-debitur/activate",
    name: "Opname Debitur",
    icon: "pe-7s-bell",
    component: ActivateOpnameDebitur,
    layout: "/admin",
  },
  {
    path: "/recommendation-chd/list-master",
    name: "List Master",
    icon: "pe-7s-bell",
    component: ListMaster,
    layout: "/admin",
  },
  {
    path: "/recommendation-chd/list-recommendation",
    name: "List Recommendation",
    icon: "pe-7s-bell",
    component: ListRecommendation,
    layout: "/admin",
  },
  {
    path: "/recommendation-chd/list-approval",
    name: "List Approval",
    icon: "pe-7s-bell",
    component: ListApproval,
    layout: "/admin",
  },
  {
    path: "/recommendation-chd/detail-master/:outlet_id_subdist/:subdist_id",
    name: "Detail Master",
    icon: "pe-7s-bell",
    component: DetailMaster,
    layout: "/admin",
  },
  {
    path: "/recommendation-chd/detail-recommendation/:outlet_id_subdist/:subdist_id",
    name: "Detail Recommendation",
    icon: "pe-7s-bell",
    component: DetailRecommendation,
    layout: "/admin",
  },
  {
    path: "/recommendation-chd/detail-approval/:id",
    name: "Detail Approval",
    icon: "pe-7s-bell",
    component: DetailApproval,
    layout: "/admin",
  },
  {
    path: "/collection/unidentified",
    name: "List Unidentified Receipt",
    icon: "pe-7s-bell",
    component: Unidentified,
    layout: "/admin",
  },
  {
    path: "/report/detail-document-monitoring",
    name: "Report Detail Document Monitoring",
    icon: "pe-7s-bell",
    component: ReportSummaryDoc,
    layout: "/admin",
  },
  {
    path: "/report/summary-document-monitoring",
    name: "Report Summary Document Monitoring",
    icon: "pe-7s-bell",
    component: ReportDocGroup,
    layout: "/admin",
  },

  {
    path: "/report/document-monitoring-internal",
    name: "Report Document Monitoring Internal",
    icon: "pe-7s-bell",
    component: ReportDocMonitoringInternal,
    layout: "/admin",
  },
  {
    path: "/report/document-reject",
    name: "Report Document Reject",
    icon: "pe-7s-bell",
    component: ReportTracesDoc,
    layout: "/admin",
  },
  {
    path: "/upload-chd/sales-target",
    name: "Sales Target",
    icon: "",
    component: SalesTarget,
    layout: "/admin",
  },
  {
    path: "/upload-chd/approval-sales-target",
    name: "Approval Sales Target",
    icon: "",
    component: ApprovalSalesTarget,
    layout: "/admin",
  },
  {
    path: "/report/traces-email-log",
    name: "Report receipt email E-Bupot",
    icon: "pe-7s-bell",
    component: TracesEmailLogBupot,
    layout: "/admin",
  },
  {
    path: "/claim/insert-bupot",
    name: "Insert Bupot",
    icon: "pe-7s-bell",
    component: InsertBupot,
    layout: "/admin",
  },
  {
    path: "/report/rpa-receipt-bupot",
    name: "Report RPA and Report Receipt E-Bupot",
    icon: "pe-7s-bell",
    component: ReportRpaReceipt,
    layout: "/admin",
  },
  {
    path: "/report/form-monitoring-wht",
    name: "Form Monitoring WHT",
    icon: "pe-7s-bell",
    component: FormMonitoringWHT,
    layout: "/admin",
  },
];
export default dashboardRoutes;
